<savvas-shared-ui-multi-progress
  class="growth-progress-bar"
  data-text-position="center"
  data-show-spacing="true"
  [multiPartProgressBarItems]="multiPartProgressBarItems"
  [popupWidth]="303"
  [isInteractive]="true"
  [rounded]="true"
  [hasPopup]="true"
  (savvasSharedUiMultiProgressBarMouseEnter)="onMultiPartProgressBarItemOnHover($event)"
>
  <app-popover-table
    [popoverHeaders]="popoverHeaders"
    [assessedStudentsPopoverList]="assessedStudentsPopoverItems"
    [popoverTableData]="popoverTableData"
  ></app-popover-table>
</savvas-shared-ui-multi-progress>
